export type FactionId = 'clan_rio' | 'guardianes_fuego' | 'susurradores' | 'sombra';

export interface Faction {
  id: FactionId;
  nombre: string;
  descripcion: string;
  lider: string;
  /** Color temático en hex, usado en UI. */
  color: string;
}

export const FACCIONES: Record<FactionId, Faction> = {
  clan_rio: {
    id: 'clan_rio',
    nombre: 'El Clan del Río',
    descripcion: 'Capibaras pacifistas, diplomáticos, viven junto al Río Ancestral.',
    lider: 'Náyade',
    color: '#7a9cc6',
  },
  guardianes_fuego: {
    id: 'guardianes_fuego',
    nombre: 'Los Guardianes del Fuego',
    descripcion: 'Guerreros de honor, patrullan los bordes del bosque.',
    lider: 'Orón',
    color: '#d94515',
  },
  susurradores: {
    id: 'susurradores',
    nombre: 'Los Susurradores',
    descripcion: 'Místicos aislados en los Acantilados Olvidados.',
    lider: 'Vega',
    color: '#6065b1',
  },
  sombra: {
    id: 'sombra',
    nombre: 'La Sombra',
    descripcion: 'Disidentes radicalizados. Antagonistas con matices.',
    lider: 'Tizón',
    color: '#2e2930',
  },
};

export type ReputationMap = Record<FactionId, number>;

export const REPUTACION_INICIAL: ReputationMap = {
  clan_rio: 0,
  guardianes_fuego: 0,
  susurradores: 0,
  sombra: 0,
};
